import React from 'react';

import { currencyFormatter } from '../../components/shared/numberFormat';
import type { Account } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';

interface LoanTotalProps {
    accounts: Account[];
}

export const LoanTotal = ({ accounts }: LoanTotalProps) => {
    const translated = useTranslation();
    const totalBalance = accounts
        .map((account) => account.balance.accountingBalance)
        .reduce((acc, cur) => acc + cur, 0);

    return (
        <div className="total-account-balance__wrapper">
            <div className="total-account-balance__content">
                {translated.accountsList.totalBalance}: <span>{currencyFormatter(totalBalance, 'NOK')}</span>
            </div>
        </div>
    );
};
